(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('ParCurvePointDetailController', ParCurvePointDetailController);

    ParCurvePointDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ParCurvePoint', 'YieldCurveResults'];

    function ParCurvePointDetailController($scope, $rootScope, $stateParams, previousState, entity, ParCurvePoint, YieldCurveResults) {
        var vm = this;

        vm.parCurvePoint = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:parCurvePointUpdate', function(event, result) {
            vm.parCurvePoint = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
